module.exports = __webpack_public_path__ + "394f07301674b0e801cb69a0ec2ff758.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/temp3x.png
// module id = 2079
// module chunks = 0